export default __webpack_public_path__ + "static/ai-in-education1-f4650c12da222b8398caf9deb7f309f7.png";